module.exports = "<gw-currency-input on-blur=\"applyNewValue\" initial-value=\"item().getValue()\" int=\"true\" currency=\"{{currency}}\"></gw-currency-input>"


//////////////////
// WEBPACK FOOTER
// ./common/grunt/webpack/loaders/text-loader!./common/js/src/edge/policycommon/common/directives/schedules/dataItems/form/templates/Currency.html
// module id = 1004
// module chunks = 0